var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',{staticClass:"text-center"},[_c('v-progress-circular',{staticClass:"mb-2",attrs:{"indeterminate":"","color":"primary"}}),_c('div',[_vm._v(" "+_vm._s(_vm.message || 'Loading...')+" ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }